/** The sun-outage badge (loader-app.js 198-223) and the terrain-mask progress line. */
import { Mountain, Sun } from 'lucide-react';
import { useAwareness } from '../../../awareness/store';
import { badgeLabel } from '../../../awareness/sunOutage';
import { useLoader } from '../../../store';
import { useNow } from './shared';

export function SunOutageCard() {
  const badge = useLoader((s) => s.sunOutage);
  const dataset = useLoader((s) => s.dataset);
  const now = useNow(1000);
  if (!badge) return null;
  const antenna = dataset?.antennas.find((a) => a.id === badge.antennaId)?.shortName ?? badge.antennaId;
  const mission = dataset?.missions.find((m) => m.id === badge.missionId)?.shortName ?? badge.missionId;
  const inProgress = badge.peakMs - now <= 0;
  return (
    <div
      className={
        inProgress
          ? 'flex items-start gap-2 border-b border-hairline bg-warning/10 px-3 py-2 text-xs'
          : 'flex items-start gap-2 border-b border-hairline bg-caution/10 px-3 py-2 text-xs'
      }
      role="status"
    >
      <Sun className={inProgress ? 'mt-0.5 h-3.5 w-3.5 shrink-0 text-warning' : 'mt-0.5 h-3.5 w-3.5 shrink-0 text-caution'} />
      <div className="leading-snug">
        <div className="font-medium text-ink">{badgeLabel(badge, now)}</div>
        <div className="text-ink-2">
          {antenna} to {mission}, {badge.durationSec} s, separation {badge.separationDeg.toFixed(2)} deg
        </div>
      </div>
    </div>
  );
}

export function TerrainProgressLine() {
  const progress = useAwareness((s) => s.terrainProgress);
  if (!progress) return null;
  return (
    <div className="flex items-center gap-2 border-b border-hairline px-3 py-1.5 text-[10px] text-ink-3">
      <Mountain className="h-3 w-3" />
      Fetching terrain masks {progress.done}/{progress.total}
      {progress.failed > 0 ? `, ${progress.failed} failed` : ''}
    </div>
  );
}
